// import Vue from 'vue'
import consts from "@/consts"
import range from "lodash/range";
import {getApiProps, updateObjectByDiff} from "@/lib/lib";
// import {arraySplitIntoChunks} from "@/lib/lib";

const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

export default {
    state: {
        reportsSchedulersFullLoad: false,
        reportsSchedulersLiteLoad: false,
        reportsSchedulers: {},
        reportsSchedulerEdit: null,
    },
    actions: {
        fetchReportsSchedulers/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchReportsSchedulers', args, time: Date.now() / 1000})

                let withRemoved = args?.without_removed ? {} : with_removed
                const params = getApiProps('reportsSchedulers', args)
                this.$api.reportsScheduler.getAll({...params, ...withRemoved})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchReportsSchedulers', args, inprogress: false})
                    });
            })
        },
        fetchReportsSchedulersAll({dispatch, commit}) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('reportsSchedulers', {})
                this.$api.reportsScheduler.getAll(params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setReportsSchedulers', response.data)
                            commit('setReportsSchedulersLiteLoad', true)
                            commit('setReportsSchedulersFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchReportsSchedulersAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchReportsSchedulersAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isReportsSchedulersLiteLoad) {
                    return resolve(getters.getReportsSchedulers.length)
                }
                dispatch('fetchReportsSchedulers', {lite: true})
                    .then((data) => {
                        commit('updateReportsSchedulers', data)
                        commit('setReportsSchedulersLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchReportsSchedulersAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchReportsSchedulersAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchReportsSchedulersAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchReportsSchedulersChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getReportsSchedulers.length) {
                        return resolve([])
                    }

                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getReportsSchedulers.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchReportsSchedulers', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateReportsSchedulers', data)
                            })
                            .catch(() => {
                                //dispatch('fetchReportsSchedulers', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setReportsSchedulersFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchReportsSchedulersAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchReportsSchedulersChanged', args, inprogress: false})
                })
        },
        fetchReportsSchedulersChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isReportsSchedulersFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchReportsSchedulersChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchReportsSchedulers', args)
                .then((data) => {
                    commit('updateReportsSchedulers', data)
                    return dispatch('fetchReportsSchedulers', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterReportsSchedulers', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchReportsSchedulersChanged', args, inprogress: false})
                });
        },

        fetchReportsScheduler({commit, dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchReportsScheduler', args, time: Date.now() / 1000})

                const params = getApiProps('reportsSchedulers', args)
                delete params.id;
                this.$api.reportsScheduler.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && response.data) {
                            commit('updateReportsScheduler', response.data)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchReportsScheduler', args, inprogress: false})
                    });
            })
        },

        saveReportsScheduler({dispatch}, reportsScheduler) {
            let fn = (reportsScheduler.id) ? 'updateReportsScheduler' : 'createReportsScheduler'
            return dispatch(fn, reportsScheduler);
        },
        createReportsScheduler({commit, dispatch}, reportsScheduler) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('reportsSchedulers')
                this.$api.reportsScheduler.create(reportsScheduler, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateReportsScheduler', response.data)
                            dispatch('fetchReportsSchedulersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateReportsScheduler({commit, dispatch}, reportsScheduler) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('reportsSchedulers')
                this.$api.reportsScheduler.update(reportsScheduler.id, reportsScheduler, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateReportsScheduler', response.data)
                            dispatch('fetchReportsSchedulersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteReportsScheduler({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('reportsSchedulers')
                this.$api.reportsScheduler.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteReportsScheduler', id)
                            else commit('updateReportsScheduler', response.data)
                            dispatch('fetchReportsSchedulersChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

    },
    mutations: {
        setReportsSchedulersFullLoad(state, FullLoad) {
            state.reportsSchedulersFullLoad = state.reportsSchedulersFullLoad || FullLoad
        },
        setReportsSchedulersLiteLoad(state, LitaLoad) {
            state.reportsSchedulersLiteLoad = state.reportsSchedulersLiteLoad || LitaLoad
        },

        setReportsSchedulers(state, nReportsSchedulers) {
            // nReportsSchedulers = nReportsSchedulers.map(u => {
            //     return u //Object.freeze(u)
            // })
            //nReportsSchedulers.sort(sortByName)
            state.reportsSchedulers = nReportsSchedulers.reduce((reportsSchedulersByIds, reportsScheduler) => {
                reportsSchedulersByIds[reportsScheduler.id] = reportsScheduler
                return reportsSchedulersByIds
            }, {})
        },

        updateReportsSchedulers(state, nReportsSchedulers) {
            if (!Object.keys(state.reportsSchedulers).length) {
                // nReportsSchedulers.sort(sortByName)
                state.reportsSchedulers = nReportsSchedulers.reduce((reportsSchedulersByIds, reportsScheduler) => {
                    reportsSchedulersByIds[reportsScheduler.id] = reportsScheduler
                    return reportsSchedulersByIds
                }, {})
                return true
            }

            nReportsSchedulers.forEach((nReportsScheduler) => {
                let reportsScheduler = state.reportsSchedulers[nReportsScheduler.id]
                if (!reportsScheduler) {
                    state.reportsSchedulers[nReportsScheduler.id] = (nReportsScheduler) //(Object.freeze(nReportsScheduler))
                } else
                if (!state.reportsSchedulersFullLoad || (reportsScheduler[changedField] != nReportsScheduler[changedField] && reportsScheduler[changedField]>0)) {
                    updateObjectByDiff(reportsScheduler, nReportsScheduler)
                    // delete nReportsScheduler.id
                    // nReportsScheduler = {...reportsScheduler, ...nReportsScheduler}
                    // reportsScheduler = nReportsScheduler //Object.freeze(nReportsScheduler)
                }
            })

        },
        filterReportsSchedulers(state, nReportsSchedulers) {
            // let Ids = state.reportsSchedulers.map(u=> u.id)
            let nIds = new Set(nReportsSchedulers.map(u => String(u.id)))
            Object.keys(state.reportsSchedulers).forEach(uid => {
                if (!nIds.has(uid)) delete state.reportsSchedulers[uid]
            })
        },
        updateReportsScheduler(state, nReportsScheduler) {
            let reportsScheduler = state.reportsSchedulers[nReportsScheduler.id]
            if (!reportsScheduler) {
                state.reportsSchedulers[nReportsScheduler.id] = (nReportsScheduler) //(Object.freeze(nReportsScheduler))
            } else
            if (!state.reportsSchedulersFullLoad || (reportsScheduler[changedField] != nReportsScheduler[changedField])) { // && reportsScheduler[changedField]>0
                updateObjectByDiff(reportsScheduler, nReportsScheduler)
                // delete nReportsScheduler.id
                // nReportsScheduler = {...reportsScheduler, ...nReportsScheduler}
                // reportsScheduler = nReportsScheduler //Object.freeze(nReportsScheduler)
            }
        },
        setReportsSchedulerEdit(state, reportsScheduler) {
            state.reportsSchedulerEdit = reportsScheduler
        },
        deleteReportsScheduler(state, id) {
            delete state.reportsSchedulers[id]
        },

        clearReportsSchedulers(state, {unitId} = {}) {
            if (unitId) {
                Object.values(state.reportsSchedulers)
                    .filter(rs => (rs.unit_id || rs.object_id) == unitId)
                    .forEach(rs => delete state.reportsSchedulers[rs.id])
            } else {
                state.reportsSchedulers = {}
                state.reportsSchedulersFullLoad = false
                state.reportsSchedulersLiteLoad = false
            }
        },
    },
    getters: {
        isReportsSchedulersFullLoad(state) {
            return state.reportsSchedulersFullLoad
        },
        isReportsSchedulersLiteLoad(state) {
            return state.reportsSchedulersLiteLoad
        },
        getReportsSchedulers(state) {
            return Object.values(state.reportsSchedulers)
        },
        getReportsSchedulersByIds(state) {
            return state.reportsSchedulers
        },
        getReportsSchedulersIdsIsFullLoad(state) {
            return Object.values(state.reportsSchedulers)
                .filter(u => (typeof u[changedField] !== 'undefined'))
                .map(u => u.id)
        },
        getReportsSchedulersFullLoadByIds(state) {
            return Object.values(state.reportsSchedulers)
                .reduce((reportsSchedulersByIds, reportsScheduler) => {
                    reportsSchedulersByIds[reportsScheduler.id] = (typeof reportsScheduler[changedField] !== 'undefined')
                    return reportsSchedulersByIds
                }, {})
        },
    }
}
